module.exports = __webpack_public_path__ + "img/261157c33e0d07c098b470a4f3a0b742.svg";